"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FracturedJsonError = void 0;
class FracturedJsonError extends Error {
    constructor(message, pos) {
        const msgWithPos = (pos) ? `${message} at idx=${pos.Index}, row=${pos.Row}, col=${pos.Column}`
            : message;
        super(msgWithPos);
        this.InputPosition = pos;
    }
}
exports.FracturedJsonError = FracturedJsonError;
